import {AutomaticEventVo} from '../../common/shared/api/gateway/event/AutomaticEventVo.interface';
import {AutomaticEvent} from '../generated/types';

export function createAutomaticEvent(data: AutomaticEventVo): AutomaticEvent {
  return {
    itemOrder: data.item_order,
    resourceUrl: data.resource_url,
    destinationTypeIos: data.destination_type_ios,
    destinationTypeAndroid: data.destination_type_android,
    destinationInfoIos: data.destination_info_ios,
    destinationInfoWeb: data.destination_info_web,
    schemeIos: data.scheme_ios,
    schemeWeb: data.scheme_web,
    schemeAndroid: data.scheme_android,
    resourceHeight: data.resource_height,
    resourceWidth: data.resource_width,
  };
}
